<template>
  <el-dialog
    append-to-body
    width="800px"
    title="邀请师傅详情"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="table.data" style="width: 100%" max-height="500">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column prop="nickname" label="姓名"> </el-table-column>
      <el-table-column prop="sex" label="性别">
        <template slot-scope="{row}">
          {{{0:'未填',1:'男',2:'女' }[row.sex] }}
        </template>
      </el-table-column>
      <el-table-column prop="kind" label="擅长工种">
        <template slot-scope="{row}">
          {{ row.kind.join("、") }}
        </template>
      </el-table-column>
      <el-table-column prop="province_str" label="所在地区">
        <template slot-scope="{row}">
          {{ row.province_str }}{{ row.city_str }}{{ row.area_str }}{{ row.street_str }}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="身份类型">
        <template slot-scope="{row}">
          <span>{{toStr({0:'未填',1:'学生',2:'自由职业',3:'宝妈',4:'全职'},row.type)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="account" label="注册号码" width="120"> </el-table-column>
      <el-table-column prop="create_time" label="注册时间" width="150"> </el-table-column>
    </el-table>
    <div class="pagination__wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="table.params.page"
        :page-size="table.params.count"
        :total="table.total"
        :page-sizes="[10, 20, 50, 100, 150]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "InviteDetail",
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
      this.getTable();
    },
    getTable() {
      let _params = {
        ...this.table.params,
        id: this.info.id,
        type: 2,
      };
      this.$http
        .get("/admin/flex_agency/user", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>
